
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import CrossroadItem from "./CrossroadItem.vue";
import ICrossroadItemModel from "./model/ICrossroadItem";

@Component({
    components: {
        CrossroadItem
    }
})
export default class Crossroad extends Vue {
    @Prop({ type: Array, default: [], validator: value => value.length > 0 }) private items!: ICrossroadItemModel[];
}
